export default {
  computed: {
    superAdmin () {
      return this.$store.state.header?.headerData?.isSuperAdmin ?? false
    }
  }
}
